import Tippy from "@tippyjs/react";
import type { ComponentProps, ReactNode } from "react";

import styles from "./Tooltip.module.css";

type TooltipProps = ComponentProps<typeof Tippy> & {
    hotkey?: string;
};

type TooltipContentProps = {
    text: ReactNode;
    hotkey?: string;
};

const TooltipContent = ({ text, hotkey }: TooltipContentProps) => {
    return (
        <>
            {text}
            {hotkey ? (
                <span
                    className={styles.hotkey}
                    // biome-ignore lint/security/noDangerouslySetInnerHtml: hotkey symbol
                    dangerouslySetInnerHTML={{
                        __html: hotkey,
                    }}
                />
            ) : null}
        </>
    );
};

export const Tooltip = ({ hotkey, children, content, ...props }: TooltipProps) => {
    return (
        <Tippy content={<TooltipContent text={content} hotkey={hotkey} />} {...props}>
            {children}
        </Tippy>
    );
};
